const DARK_BASEMAPS = [
    "Imagery", "Imagery Hybrid", "Streets (Night)", "Dark Gray Canvas",
    "Navigation (Dark)", "Nova Map", "Firefly Imagery Hybrid", "Blueprint",
    "Enhanced Contrast Dark Map", "Human Geography Dark Map",
    "სატელიტური", "სატელიტურ ჰიბრიდული", "ქუჩების (ღამე)", "მუქი ნაცრისფერი ტილო",
    "ნავიგაციური ბნელი", "ნოვას რუკა", "მანათობელი სატელიტური რუკა",
    "გეგმური", "გაძლიერებულ კონტრასტული მუქი რუკა", "საზოგადოებრივ გეოგრაფიული მუქი რუკა",
];

const TITLE_MAP = {
    "Topographic": "ტოპოგრაფიული",
    "Streets": "ქუჩები",
    "Imagery": "სატელიტური",
    "Imagery Hybrid": "სატელიტურ ჰიბრიდული",
    "Navigation": "ნავიგაციური",
    "Navigation (Dark)": "ნავიგაციური ბნელი",
    "Newspaper Map": "გაზეთის რუკა",
    "Community Map": "საზოგადოებრივი",
    "Streets (Night)": "ქუჩების (ღამე)",
    "Terrain with Labels": "ფიზიკურ ტვისობრივი ეტიკეტები",
    "Light Gray Canvas": "ღია ნაცრისფერი ტილო",
    "Dark Gray Canvas": "მუქი ნაცრისფერი ტილო",
    "Outdoor": "გარე სივრცის",
    "Oceans": "ოკეანეების",
    "National Geographic Style Map": "ნაციონალური გეოგრაფიული რუკა",
    "OpenStreetMap": "ღია ქუჩების რუკა",
    "Charted Territory Map": "კარტირებული ტერიტორიების რუკა",
    "Human Geography Map": "საზოგადოებრივ გეოგრაფიული რუკა",
    "Human Geography Dark Map": "საზოგადოებრივ გეოგრაფიული მუქი რუკა",
    "Modern Antique Map": "თანამედროვე ანტიკური რუკა",
    "Mid-Century Map": "შუასაუკუნეების რუკა",
    "Nova Map": "ნოვას რუკა",
    "Colored Pencil Map": "ფერადი ფანქრის რუკა",
    "Firefly Imagery Hybrid": "მანათობელი სატელიტური რუკა",
    "Blueprint": "გეგმური",
    "Enhanced Contrast Map": "გაძლიერებული კონტრასტული რუკა",
    "Enhanced Contrast Dark Map": "გაძლიერებულ კონტრასტული მუქი რუკა",
    "Topographic (Vector)": "ტოპოგრაფიული რუკა (ვექტორული)",
    "Environment Map": "ეკოლოგიური რუკა",
    "Navigation (Places)": "ნავიგაცია (ადგილები)",
    "Navigation (Dark - Places)": "ნავიგაცია (მუქი თემა – ადგილები)",
};

export const setupBasemapGallery = (view, BasemapGallery, reactiveUtils, t, contextParams = {}) => {
    const { onBasemapChange, panelContainer } = contextParams;

    // ─── Container ───────────────────────────────────────────────────────────
    // Panel mode  → use the provided #basemapGalleryDiv directly (no floating overlay)
    // Legacy mode → create a floating overlay appended to the map container
    let galleryDiv;
    let customButton = null;
    let iconImg = null;

    if (panelContainer) {
        galleryDiv = panelContainer;
        Object.assign(galleryDiv.style, {
            background: "transparent",
            width: "100%",
            boxSizing: "border-box",
        });
    } else {
        const viewContainer = view.container;
        galleryDiv = document.createElement("div");
        galleryDiv.className = "custom-basemap-gallery-floating";
        Object.assign(galleryDiv.style, {
            position: "absolute",
            bottom: "90px",
            left: "20px",
            zIndex: "3000",
            display: "none",
            width: "350px",
            maxHeight: "450px",
            overflowY: "auto",
            transition: "left 0.3s ease-in-out, opacity 0.3s ease-in-out",
            background: "transparent",
            backdropFilter: "blur(30px)",
            webkitBackdropFilter: "blur(30px)",
            border: "0.5px solid rgba(255,255,255,0.2)",
            boxShadow: "0 0 10px rgba(255,255,255,0.2)",
            borderRadius: "10px",
        });
        viewContainer.appendChild(galleryDiv);

        // Floating toggle button (legacy mode only)
        customButton = document.createElement("div");
        customButton.className = "custom-basemap-toggle-btn-floating";
        Object.assign(customButton.style, {
            position: "absolute",
            bottom: "15px",
            left: "15px",
            zIndex: "2001",
            cursor: "pointer",
            width: "60px",
            height: "60px",
            backgroundColor: "black",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "4px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.5)",
        });
        iconImg = document.createElement("img");
        Object.assign(iconImg.style, { width: "54px", height: "54px", borderRadius: "2px", objectFit: "cover" });
        customButton.appendChild(iconImg);
        viewContainer.appendChild(customButton);

        customButton.onclick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            galleryDiv.style.display = galleryDiv.style.display === "none" ? "block" : "none";
        };
    }

    // ─── BasemapGallery widget ────────────────────────────────────────────────
    const basemapGallery = new BasemapGallery({
        view,
        container: galleryDiv,
        source: { portal: { url: "https://www.arcgis.com", useVectorBasemaps: true } },
    });

    // Grid layout after widget renders
    reactiveUtils.when(() => basemapGallery.container, (container) => {
        const gridContainer = container.querySelector(".esri-basemap-gallery__item-container");
        if (gridContainer) {
            gridContainer.style.display = "grid";
            gridContainer.style.setProperty("grid-template-columns", "repeat(3, 1fr)", "important");
            gridContainer.style.background = "transparent";
            gridContainer.style.gap = "10px";
            gridContainer.style.padding = "10px";
        }
        const galleryWidget = container.querySelector(".esri-basemap-gallery");
        if (galleryWidget) galleryWidget.style.background = "transparent";
    });

    // Basemap change watcher
    basemapGallery.watch("activeBasemap", (bm) => {
        if (iconImg && bm?.thumbnailUrl) iconImg.src = bm.thumbnailUrl;
        if (!panelContainer) galleryDiv.style.display = "none"; // close floating on select
        if (onBasemapChange && bm) {
            onBasemapChange(DARK_BASEMAPS.includes(bm.title));
        }
    });

    // Set initial icon (legacy mode)
    if (iconImg) {
        reactiveUtils.whenOnce(() => basemapGallery.activeBasemap).then((bm) => {
            if (bm?.thumbnailUrl) iconImg.src = bm.thumbnailUrl;
        });
    }

    // ─── Title translations ───────────────────────────────────────────────────
    function ensureBasemapsLoaded(bg) {
        return new Promise((resolve) => {
            const check = () => {
                if (bg.source.basemaps.every((b) => b.loaded)) resolve();
                else setTimeout(check, 100);
            };
            check();
        });
    }

    const updateBasemapTitles = (bg) => {
        if (!bg?.source?.basemaps) return;
        bg.source.basemaps.forEach((basemap) => {
            if (basemap.loaded && TITLE_MAP[basemap.title]) {
                basemap.title = t(TITLE_MAP[basemap.title]);
            }
        });
        bg.render();
    };

    basemapGallery.watch("source.basemaps.length", async () => {
        await ensureBasemapsLoaded(basemapGallery);
        updateBasemapTitles(basemapGallery);
    });

    return basemapGallery;
};
